"use strict";

exports.__esModule = true;
var _DeviceRoutesPlantTwin = require("./DeviceRoutesPlantTwin");
Object.keys(_DeviceRoutesPlantTwin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceRoutesPlantTwin[key]) return;
  exports[key] = _DeviceRoutesPlantTwin[key];
});